<template>
  <div>
    <contractDetail :createTempBill="true"/>
    <row class="p-t-10">
      <i-col span="24">
        <Button type="info" @click="handlePreviousStep">上一步</Button>
        <div class="right">
          <Button type="warning" @click="confirmContract">提交合同</Button>
        </div>
      </i-col>
    </row>

    <Spin fix v-if="submitLoading">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>合同提交中</div>
    </Spin>
  </div>
</template>

<script>
// import { getPositions } from '@/api/product/resource'
// import { addDevice, updateDevice } from '@/api/product/deviceedit'
import contractDetail from '@/components/investmentContract/modalComponents/detail.vue'
/** new api */

import { submitContract } from '@/api/invest/contract'

export default {
  components: { contractDetail },
  props: {},
  data () {
    return {
      submitLoading: false
    }
  },
  mounted () {},
  created () {
  },
  methods: {
    confirmContract () {
      this.$Modal.confirm({
        title: '操作确认',
        content:
          '确认提交合同？',
        onOk: () => {
          this.submitLoading = true

          submitContract({ contractId: this.contractInfo.id }).then((res) => {
            this.submitLoading = false
            this.$store.commit('set_contract_pageType', 'list')
            // this.$store.commit('set_contract_currentStep', 'other')
            this.$store.commit('set_contract_update', new Date())
          })
        }
      })
    },
    handlePreviousStep () {
      this.$store.commit('set_contract_currentStep', 'files')
      this.$store.commit('set_contract_update', new Date())
    },
    handleNextStep () {

    }
  },
  watch: {
  },
  computed: {
    contractInfo () {
      return this.$store.state.investmentContract.contractInfo
    }
  }
}
</script>
